import React from 'react';

const sortOptions = [
    { label: 'Relevant', value: 'relevant' },
    { label: 'Recent', value: 'recent' },
];

const SortOption = ({ currentOption, option, onChangeSort }) => {
    const { label, value } = option;
    return (
        <div
            style={{
                color: currentOption === value ? '#3c828c' : '#053364',
                fontSize: '.75rem',
                fontWeight: 500,
                textTransform: 'uppercase',
                cursor: 'pointer',
                borderBottom: 2,
                borderBottomColor: currentOption === value ? '#aed3f7' : 'transparent',
                borderBottomStyle: 'solid',
                paddingBottom: 1,
            }}
            onClick={() => onChangeSort(value)}
        >
            {label}
        </div>
    );
};

const Sort = ({ currentSortOption, onChangeSort }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'end', paddingBottom: 20 }}>
            <div className="filters__sort">
                <div
                    style={{
                        color: '#053364',
                        fontSize: '.75rem',
                        fontWeight: 500,
                        textTransform: 'uppercase',
                        marginRight: '14.85px',
                        paddingBottom: 3,
                    }}
                >
                    Sort By
                </div>
                {sortOptions.map((option, index) => (
                    <React.Fragment key={option.value}>
                        <SortOption currentOption={currentSortOption} option={option} onChangeSort={onChangeSort} />
                        {index !== sortOptions.length - 1 && <span className="filters__spacer">&nbsp;|&nbsp;</span>}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default Sort;
